import shipmentTracking from "./shipment-tracking";
import draftFilters from "./drafts-filters";
import customers from "./customers";
import partnerRelationships from "./partner-relationships";
import subscriptionsAirFilter from "./subscriptions-air-filter";
import emissions from "./emissions";
import lookup from "./lookup";
import excelUpload from "./excel-upload";
import downloadLists from "./global/downloadReports";
import sseEvents from "./sse-events";
import disruptions from "./risk-management/disruptions";
import mrmRiskData from "./risk-management/risk-data";
import mrmRiskLocationData from "./risk-management/risk-location-data";
import asyncUploadFile from "./async-upload/index";
import uploadReports from "./global/uploadReports";
import reporting from "./reporting";
import carrierPerformanceConfigs from "./carrier-performance/configs";
import { performanceByCarrier, performanceByGeography, reliabilityTimeline } from "./carrier-performance/reliability";
import { transitPerformanceByCarrier, transitPerformanceByLane, transitTimeline } from "./carrier-performance/transit";
import { deviation } from "./carrier-performance/deviation";
import { varianceTrend } from "./carrier-performance/variance";
import {
  createSession as transitTargetCreateSession,
  uploadBatch as transitTargetUploadBatch,
  getErrorReport as transitTargetGetErrorReport,
  getTargetCoverage as transitTargetGetCoverage
} from "./carrier-performance/transit-target-upload";
import bookings from "./bookings";
import { getYearOnYearTrend, getYearOnYearByPort } from "./bookings/year-on-year";

export default {
  shipmentTracking,
  draftFilters,
  customers,
  partnerRelationships,
  subscriptionsAirFilter,
  emissions,
  lookup,
  excelUpload,
  downloadLists,
  sseEvents,
  disruptions,
  mrmRiskData,
  mrmRiskLocationData,
  asyncUploadFile,
  uploadReports,
  reporting,
  carrierPerformanceConfigs,
  performanceByCarrier,
  performanceByGeography,
  reliabilityTimeline,
  transitPerformanceByCarrier,
  transitPerformanceByLane,
  transitTimeline,
  deviation,
  varianceTrend,
  transitTargetCreateSession,
  transitTargetUploadBatch,
  transitTargetGetErrorReport,
  transitTargetGetCoverage,
  bookings,
  getYearOnYearTrend,
  getYearOnYearByPort
};
